import type {RegionRequest, RegionResponse} from 'src/api/ProactApiClient';
import type {IFormFieldV2} from 'src/types/FormV2';

export const RegionDocumentTitle = 'Regions';

export const RegionFormMeta: IFormFieldV2[] = [
  {
    name: 'name',
    label: 'Name',
    type: 'text',
    required: true,
    size: 'md',
    validation: {maxLength: 250},
  },
  {
    name: 'notes',
    label: 'Notes',
    type: 'textarea',
    required: false,
    validation: {maxLength: 2000},
    textboxOptions: {multiline: true},
  },
];

// Newtonsoft sends explicit `null` where the generated types say `undefined` —
// normalize at this response -> request boundary.
export const MapRegionResponseToRegionRequest = (
  data: RegionResponse
): RegionRequest => ({
  id: data.id,
  name: data.name ?? undefined,
  notes: data.notes ?? undefined,
});
